import { RootStore } from '../../data/store'
export const getAPIBody = (bankId: string) => {
  return {
    mobile: {
      countryCode: '91',
      mobileNumber: RootStore.settings.metaData.mobileNumber,
    },
    bankCode: bankId,
  }
}
